import axios from "axios";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import { v1 as uuidv1 } from "uuid";
import { supplierPendingValues } from "./functions";
import Autocomplete from "@mui/material/Autocomplete";
import { useNavigate } from "react-router-dom";
import { apiURI, authErrorRedirect, useSupplierList } from "../../common";
import { validateSaveSuppliers } from "./validation/validateSaveSuppliers";

export function SampleRequestApprovalProcurementAddSupplierModal(props) {
  const [values, setValues] = useState();
  const [pendingValues, setPendingValues] = useState(
    supplierPendingValues(props.detailsData)
  );
  const { listOfSuppliers = [] } = useSupplierList();
  const [addDisabled, setAddDisabled] = useState(false);
  const history = useNavigate();

  useEffect(() => {
    setValues([
      {
        name: null,
        email: "",
        ...pendingValues,
      },
    ]);
    setAddDisabled(false);
  }, [pendingValues]);

  const [errors, setErrors] = useState();

  const handleClose = () => {
    props.setOpen(false);
    setValues([
      {
        name: null,
        email: "",
        ...pendingValues,
      },
    ]);
    setErrors();
    setAddDisabled(false);
  };
  let handleChange = (i, e) => {
    let newFormValues = [...values];
    newFormValues[i][e.target.name] = e.target.value;
    setValues(newFormValues);
  };

  let addFormFields = () => {
    setValues([...values, { name: null, email: "", ...pendingValues }]);
    let newSuppliers = values.length + 1;
    if (newSuppliers >= props.maxSuppliers) setAddDisabled(true);
  };

  function removeFormFields(i) {
    //remove fields
    let newFormValues = [...values];
    newFormValues.splice(i, 1);
    setValues(newFormValues);
    //remove errors for the fields
    if (errors) {
      let errorValues = [...errors];
      errorValues.splice(i, 1);
      setErrors(errorValues);
    } else {
      setErrors();
    }
    let newSuppliers = values.length - 1;
    if (newSuppliers < props.maxSuppliers) setAddDisabled(false);
  }
  async function handleAddSupplier() {
    setErrors({});

    const newList = props.itemList.map((item) =>
      [...props.selectedRowsData].includes(item.sampleItemID)
        ? {
            ...item,
            supplierList: [
              ...item.supplierList,
              ...values.map((supplier) => {
                return {
                  qualityReportsID: `QR-ID-${uuidv1()}-${Math.floor(
                    Math.random() * 9999
                  )}`,
                  ...supplier,
                };
              }),
            ],
          }
        : item
    );

    let newData = {
      ...props.detailsData,
      dateModified: Date.now(),
      items: newList,
    };

    await axios
      .post(`${apiURI}/form/procAddSupplier`, newData)
      .then(() => {
        setValues({});
        window.location.reload(true);
      })
      .catch((response) => {
        console.log("error in axios form call react");
        setErrors({});
        setErrors(response.response.data);
        authErrorRedirect(response.response.data, history);
      });

    handleClose();

    // eslint-disable-next-line no-console
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    const { validationErrors, isValid } = validateSaveSuppliers(values);
    !isValid && setErrors(validationErrors);

    isValid && handleAddSupplier(values);
  };

  return (
    <div>
      {values && (
        <Dialog
          open={props.open}
          onClose={handleClose}
          style={{
            height: "90%",
          }}
          PaperProps={{ sx: { borderRadius: "20px" } }}
        >
          <Box
            sx={{
              display: props.display,
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Container
              component="main"
              maxWidth="sm"
              sx={{
                marginTop: 4,
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography component="h1" variant="h5">
                Add Supplier(s)
              </Typography>
              <CssBaseline />
              <Box component="form" noValidate>
                {values.map((inputField, index) => {
                  const currentItem = values[index];
                  return (
                    <Grid item key={index} xs={12} sm={12}>
                      <Grid item xs={12} sm={12}>
                        <Typography
                          component="h1"
                          variant="subtitle1"
                          gutterBottom
                          mt={4}
                        >
                          Supplier {index + 1}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={12} mb={2}>
                        <Autocomplete
                          style={{ width: "400px" }}
                          options={listOfSuppliers}
                          value={currentItem.name}
                          onChange={(e, supplierName) => {
                            let newFormValues = [...values];
                            newFormValues[index].name = supplierName;
                            setValues(newFormValues);
                          }}
                          loading
                          freeSolo
                          autoSelect
                          renderInput={(params) => {
                            return (
                              <TextField
                                label="Select Supplier"
                                {...params}
                                error={
                                  errors &&
                                  errors.length > index &&
                                  errors[index].name &&
                                  errors[index].name !== "" &&
                                  true
                                }
                                helperText={
                                  errors &&
                                  errors.length > index &&
                                  errors[index].name &&
                                  errors[index].name !== ""
                                    ? errors[index].name
                                    : ""
                                }
                              />
                            );
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <TextField
                          name="email"
                          required
                          style={{ width: "400px" }}
                          id={`EmailField${index}`}
                          label="Supplier Email"
                          value={currentItem.email}
                          onChange={(e) => handleChange(index, e)}
                          error={
                            errors &&
                            errors.length > index &&
                            errors[index].email &&
                            errors[index].email !== "" &&
                            true
                          }
                          helperText={
                            errors &&
                            errors.length > index &&
                            errors[index].email &&
                            errors[index].email !== ""
                              ? errors[index].email
                              : ""
                          }
                        />
                      </Grid>
                      {index ? (
                        <Button
                          variant="contained"
                          sx={{
                            mt: 7,
                            mb: 2,
                            width: "150px",
                          }}
                          onClick={() => removeFormFields(index)}
                        >
                          Remove
                        </Button>
                      ) : null}
                    </Grid>
                  );
                })}

                <Grid
                  container
                  spacing={2}
                  sx={{
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  <Grid item>
                    <Button
                      variant="contained"
                      disabled={addDisabled}
                      sx={{
                        mt: 7,
                        mb: 2,
                        width: "150px",
                      }}
                      onClick={() => addFormFields()}
                    >
                      Add
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      onClick={handleSubmit}
                      variant="contained"
                      sx={{
                        mt: 7,
                        mb: 2,
                        width: "150px",
                      }}
                    >
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Container>
          </Box>
        </Dialog>
      )}
    </div>
  );
}
